
import { computed, defineComponent, ref } from 'vue'
import { store } from '@/store'
import AppLogo from '@/components/atoms/AppLogo.vue'
import router from '@/router'
import { toast } from '@/api/tools'

export default defineComponent({
  name: 'TripplyHeader',
  components: { AppLogo },
  setup() {

    const scrolled = ref(false)

    window.document.body.onscroll = () => {
      scrolled.value = window.pageYOffset > 0
    }

    const nav = ref(false)

    function signIn() {
      store.modal.showModal('SignIn')
    }
    function signUp() {
      store.modal.showModal('SignIn', { signUp: true })
    }
    function closeNav() {      
      nav.value = false
    }
    function signOut() {
      store.auth.signOut()
      closeNav()
    }
    function changeTheme() {
      store.global.changeTheme()
    }

    function shareLove() {
      toast({title: 'Tak fordi du deler kærligheden!', type: 'love'})
    }

    const user = store.auth.get(state => state.user)
    const subscription = computed(() => store.user.state.subscription)    
    const photoURL = user.value ? user.value.photoURL : null
    const firstName = store.user.firstName
    const theme = store.global.get(state => state.theme)
    const authLoading = store.auth.get(state => state.loading)

    return { user, closeNav, photoURL, firstName, signIn, signUp, signOut, subscription, nav, changeTheme, theme, authLoading, scrolled, shareLove }
  }
})
